import { render, staticRenderFns } from "./PropertiesListCriterion.vue?vue&type=template&id=2a7bfa7a&"
import script from "./PropertiesListCriterion.vue?vue&type=script&lang=ts&"
export * from "./PropertiesListCriterion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports